export default {
  methods: {
    $helloWorld: function () {
      console.log('hello world!')
    }
  }
}
